import { createMemo } from '@packages/react';
import { color, ColorType } from '@packages/style/colors';
import React from 'react';
import styled from 'styled-components';

interface ColorProps {
    [key: string]: any;

    component: any;
    color?: ColorType;
}

const ColorStyle = styled(
    createMemo<ColorProps>(({ component: Component, color, ...rest }) => <Component {...rest} />, {
        displayName: 'ColorStyle',
    }),
)`
    && {
        color: ${color('color', 'inherit')};
    }
`;

export const Color = createMemo<ColorProps>(({ ...rest }) => <ColorStyle {...rest} />, {
    displayName: 'Color',
});
